export default __webpack_public_path__ + "static/media/listening2.17fa93b1.svg";